<template>
  <div>
    <h1 class="mb-4">
      <v-icon color="error" large>mdi-bell-alert</v-icon>
      Alertas de Membresías
    </h1>

    <!-- Resumen rápido -->
    <v-row class="mb-4">
      <v-col cols="6" sm="3" v-for="card in resumenCards" :key="card.label">
        <v-card :color="card.color" dark rounded="xl" class="text-center pa-3">
          <div class="text-h4 font-weight-black">{{ card.valor }}</div>
          <div class="text-caption">{{ card.label }}</div>
        </v-card>
      </v-col>
    </v-row>

    <!-- Tabs -->
    <v-card rounded="xl" class="elevation-3">
      <v-tabs v-model="tab" color="primary" grow>
        <v-tab><v-icon left small>mdi-alert-circle</v-icon> Urgente (3 días)</v-tab>
        <v-tab><v-icon left small>mdi-calendar-week</v-icon> Esta semana</v-tab>
        <v-tab><v-icon left small>mdi-calendar</v-icon> 30 días</v-tab>
        <v-tab><v-icon left small>mdi-clock-alert</v-icon> Ya vencidos</v-tab>
        <v-tab><v-icon left small>mdi-account-off</v-icon> Sin membresía</v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item v-for="(lista, idx) in [vencen3, vencen7, vencen30, yaVencidos, sinMembresia]" :key="idx">
          <v-card flat>
            <v-data-table
              :items="lista"
              :headers="idx < 4 ? headersVencen : headersSin"
              :loading="cargando"
              class="elevation-0"
              no-data-text="¡Sin alertas en esta categoría! 🎉"
            >
              <template v-slot:[`item.imagen`]="{ item }">
                <v-avatar size="36"><img :src="urlImg(item.imagen)" /></v-avatar>
              </template>
              <template v-slot:[`item.diasRestantes`]="{ item }">
                <v-chip small :color="item.diasRestantes <= 3 ? 'error' : item.diasRestantes <= 7 ? 'warning' : 'info'" dark>
                  {{ item.diasRestantes }} días
                </v-chip>
              </template>
              <template v-slot:[`item.diasVencido`]="{ item }">
                <v-chip small color="error" dark>Venció hace {{ item.diasVencido }} días</v-chip>
              </template>
              <template v-slot:[`item.acciones`]="{ item }">
                <v-btn small color="success" rounded @click="renovar(item)">
                  <v-icon left small>mdi-refresh</v-icon> Renovar
                </v-btn>
              </template>
            </v-data-table>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>

    <!-- Dialog renovación -->
    <v-dialog v-model="mostrarPago" persistent max-width="600">
      <realizar-pago
        v-if="matriculaSeleccionada"
        :matricula="matriculaSeleccionada"
        @cerrar="mostrarPago = false"
        @pagado="onPagado"
      />
    </v-dialog>

    <v-overlay :value="cargando">
      <v-progress-circular indeterminate size="64" />
    </v-overlay>
  </div>
</template>

<script>
import HttpService from '../../Servicios/HttpService'
import Utiles from '../../Servicios/Utiles'
import RealizarPago from '../Miembros/RealizarPago.vue'

export default {
  name: 'AlertasComponent',
  components: { RealizarPago },
  data: () => ({
    tab: 0,
    cargando: false,
    vencen3: [], vencen7: [], vencen30: [], yaVencidos: [], sinMembresia: [],
    resumen: {},
    mostrarPago: false,
    matriculaSeleccionada: '',
    headersVencen: [
      { text: '', value: 'imagen', sortable: false, width: 56 },
      { text: 'Nombre', value: 'nombre' },
      { text: 'Matrícula', value: 'matricula' },
      { text: 'Teléfono', value: 'telefono' },
      { text: 'Membresía', value: 'membresia' },
      { text: 'Vence', value: 'fechaFin' },
      { text: 'Días', value: 'diasRestantes' },
      { text: 'Acción', value: 'acciones', sortable: false },
    ],
    headersSin: [
      { text: '', value: 'imagen', sortable: false, width: 56 },
      { text: 'Nombre', value: 'nombre' },
      { text: 'Matrícula', value: 'matricula' },
      { text: 'Teléfono', value: 'telefono' },
      { text: 'Acción', value: 'acciones', sortable: false },
    ],
  }),
  computed: {
    resumenCards() {
      return [
        { label: 'Urgente (≤3 días)', valor: this.vencen3.length, color: 'red darken-2' },
        { label: 'Esta semana', valor: this.vencen7.length, color: 'orange darken-2' },
        { label: 'Este mes', valor: this.vencen30.length, color: 'blue darken-1' },
        { label: 'Ya vencidos', valor: this.yaVencidos.length, color: 'grey darken-2' },
      ]
    },
  },
  mounted() { this.cargar() },
  methods: {
    async cargar() {
      this.cargando = true
      const data = await HttpService.obtenerAlertas()
      if (data) {
        this.vencen3      = data.vencen7.filter(m => m.diasRestantes <= 3)
        this.vencen7      = data.vencen7
        this.vencen30     = data.vencen30
        this.yaVencidos   = data.yaVencidos
        this.sinMembresia = data.sinMembresia
        this.resumen      = data.resumen || {}
      }
      this.cargando = false
    },
    renovar(miembro) {
      this.matriculaSeleccionada = miembro.matricula
      this.mostrarPago = true
    },
    onPagado(ok) {
      if (ok) { this.mostrarPago = false; this.cargar() }
    },
    urlImg(img) { return Utiles.generarURL(img) },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Alertas/AlertasComponent.vue